// @flow
import {
  fetchListing as apiFetchListing,
  hideListing as apiHideListing,
  unhideListing as apiUnhideListing,
  publishListing as apiPublishListing,
  deleteListing as apiDeleteListing
} from 'api/groupAdmin';
import type { Dispatch, GetState } from '../..';
import { setError } from '../error';
import { clearResults } from '../mainSearch';

type FetchListingRequestAction = {
  type: 'GROUP_DASHBOARD_FETCH_LISTING_REQUEST',
  listingId: string
};
type FetchListingSuccessAction = {
  type: 'GROUP_DASHBOARD_FETCH_LISTING_SUCCESS',
  listing: Object
};
type ResetListingAction = { type: 'GROUP_DASHBOARD_RESET_LISTING' };

export type Action =
  | FetchListingRequestAction
  | FetchListingSuccessAction
  | ResetListingAction;

const fetchListingRequest = (listingId: string): FetchListingRequestAction => ({
  type: 'GROUP_DASHBOARD_FETCH_LISTING_REQUEST',
  listingId
});

const fetchListingSuccess = (listing: Object): FetchListingSuccessAction => ({
  type: 'GROUP_DASHBOARD_FETCH_LISTING_SUCCESS',
  listing
});

export const fetchListing = ({
  groupId,
  listingType,
  listingId,
  force
}: {
  groupId: string,
  listingType: 'VOLOP',
  listingId: string,
  force?: boolean
}) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const listing = state.groupDashboard.listings.byId[listingId];

  if (!listing || force) {
    dispatch(fetchListingRequest(listingId));
    apiFetchListing(groupId, listingType, listingId)
      .then(fetchedListing => {
        dispatch(fetchListingSuccess(fetchedListing));
      })
      .catch(error => {
        dispatch(setError(error));
      });
  }
};

export const updateListing = fetchListingSuccess;

export const hideListing = ({
  groupId,
  listingType,
  listingId
}: {
  groupId: string,
  listingType: 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiHideListing({ groupId, listingType, listingId })
    .then(listing => {
      dispatch(updateListing(listing));
      dispatch(clearResults());
    })
    .catch(setError);

export const unhideListing = ({
  groupId,
  listingType,
  listingId
}: {
  groupId: string,
  listingType: 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiUnhideListing({ groupId, listingType, listingId })
    .then(listing => {
      dispatch(updateListing(listing));
      dispatch(clearResults());
    })
    .catch(setError);

export const publishListing = ({
  groupId,
  listingType,
  listingId
}: {
  groupId: string,
  listingType: 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiPublishListing({ groupId, listingType, listingId })
    .then(listing => {
      dispatch(updateListing(listing));
      dispatch(clearResults());
    })
    .catch(setError);

export const deleteListing = ({
  groupId,
  listingType,
  listingId
}: {
  groupId: string,
  listingType: 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiDeleteListing({ groupId, listingType, listingId })
    .then(deletedListing => {
      dispatch(updateListing(deletedListing));
      dispatch(clearResults());
    })
    .catch(setError);

export const resetListing = () => (dispatch: Dispatch) =>
  dispatch({ type: 'GROUP_DASHBOARD_RESET_LISTING' });
